import { render, staticRenderFns } from "./BankConfigureTerminalBookings.vue?vue&type=template&id=75b91e78&scoped=true"
import script from "./BankConfigureTerminalBookings.vue?vue&type=script&lang=ts"
export * from "./BankConfigureTerminalBookings.vue?vue&type=script&lang=ts"
import style0 from "./BankConfigureTerminalBookings.vue?vue&type=style&index=0&id=75b91e78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b91e78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b91e78')) {
      api.createRecord('75b91e78', component.options)
    } else {
      api.reload('75b91e78', component.options)
    }
    module.hot.accept("./BankConfigureTerminalBookings.vue?vue&type=template&id=75b91e78&scoped=true", function () {
      api.rerender('75b91e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/BankConfigureTerminalBookings.vue"
export default component.exports